import { controls, grouped } from "../controls";
const accounts = {
  label: "Accounts",
  pageLabel: "Accounts", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  formTabs:
  {
    allTabs: [
      { label: "General", uid: "general" },
      { label: "Loan", uid: "ac_loan_info", parents: [{ "name": "product_group", "match": "in", "value": ["Loan"] }], fastpath: "ac_loan_infos" },
      { label: "Term Deposit", uid: "term_deposit", parents: [{ "name": "product_type", "match": "in", "value": ["Fixed Deposit", "Pension Deposit", "Call Deposit", "Reinvestment Deposit"] }], fastpath: "term_deposits" },
      { label: "Recurring Deposit", uid: "recurring_deposit", parents: [{ "name": "product_type", "match": "in", "value": ["Recurring Deposit"] }], fastpath: "recurring_deposit" },
      { label: "Pigmy Deposit", uid: "pigmy_deposit", parents: [{ "name": "product_type", "match": "in", "value": ["Pigmy Deposit"] }], fastpath: "pigmy_deposit" },
      { label: "Installments", uid: "account_installment", parents: [{ "name": "product_type", "match": "in", "value": ["Installment Loan", "Gold Loan Installment", "Housing Loan"] }], fastpath: "account_installments" },
      { label: "Account Balance", uid: "account_balance", fastpath: "account_balances" },
      { label: "Nominees", uid: "ac_nominees", parents: [{ "name": "product_group", "match": "in", "value": ["Deposit", "Loan"] }], fastpath: "nominees" },
      { label: "Joints", uid: "account_joints", parents: [{ "name": "product_group", "match": "in", "value": ["Loan", "Deposit"] }], fastpath: "account_joint" },
      { label: "Guarantors", uid: "account_guarantors", parents: [{ "name": "product_group", "match": "in", "value": ["Loan"] }], fastpath: "account_guarantors" },
      { label: "Insurances", uid: "account_insurances", parents: [{ "name": "product_group", "match": "in", "value": ["Loan"] }], fastpath: "account_insurances" },
      { label: "Gold", uid: "account_gold_details", parents: [{ "name": "product_type", "match": "in", "value": ["Gold Loan", "Gold Loan Installment"] }], fastpath: "account_gold_details" },
      { label: "Vehicle", uid: "account_vehicle_details", parents: [{ "name": "product_type", "match": "in", "value": ["Vehicle Loan"] }], fastpath: "account_vehicle_details" },
      { label: "Lien", uid: "account_lien_details", parents: [{ "name": "product_type", "match": "in", "value": ["Cash Credit Against Deposit", "Loan against Fixed Deposit"] }], fastpath: "account_liens" },
      { label: "Security", uid: "account_security_details", parents: [{ "name": "product_group", "match": "in", "value": ["Loan"] }], fastpath: "account_securities" },
      { label: "Documents", uid: "account_documents", fastpath: "account_documents" },
      { label: "House", uid: "account_house_details", parents: [{ "name": "product_type", "match": "in", "value": ["Housing Loan"] }], fastpath: "account_house_details" }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Customer" }),
    ...controls.oc({ tab: "filter", c: "Customer", placeHolder: "Customer Code", name: "Account-customer-customer_code", fastpath: "customers" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "Account-customer-customer_display" }),
    ...controls.displayText({ tab: "filter", label: "Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "account_code", maxlength: 20 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Product" }),
    ...controls.oc({ tab: "filter", c: "Product", placeHolder: "Product Code", name: "Account-product-product_code", fastpath: "products" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "Account-product-product_display" }),
    ...controls.displayText({ tab: "filter", label: "Account Type" }),
    ...controls.autoComplete({ tab: "filter", name: "Account-account_type-account_type_code", width: "col-sm-2", controlType: "AccountType" }),
    ...controls.displayText({ tab: "filter", label: "" }),
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", placeHolder: "Branch Code", name: "Account-branch-branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "Account-branch-branch_display" }),
    ...controls.displayText({ tab: "filter", label: "Product Group" }),
    ...controls.autoComplete({ tab: "filter", name: "Account-product-product_group-product_group_code", width: "col-sm-2", controlType: "ProductGroup" }),
    ...controls.displayText({ tab: "filter", label: "" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Branch", star: true }),
    ...controls.oc({ tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", isRequired: true, fastpath: "branches", isReadOnly: "edit", isReadOnly: true, defaultValue: 'assigned_branch', hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display" }),
    ...controls.displayText({ tab: "general", label: "Code", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "account_code", maxlength: 20, isReadOnly: "edit", isRequired: false, isReadOnly: true }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Product", star: true }),
    ...controls.oc({ tab: "general", c: "Product", placeHolder: "Product Code", name: "product_code", isRequired: true, fastpath: "products", isReadOnly: "edit", displayData: { product_group: "product_group", product_type: "product_type", product_type_uid: "product_type_uid" }, hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "product_display" }),
    ...controls.displayText({ tab: "general", label: "Interest Rate" }),
    ...controls.floatOnly({ tab: "general", placeHolder: "", name: "int_rate", maxlength: 6, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Account Type", star: true }),
    ...controls.autoComplete({ tab: "general", name: "account_type_code", width: "col-sm-2", controlType: "AccountType" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Customer", star: true }),
    ...controls.oc({ tab: "general", c: "Customer", placeHolder: "Customer Code", name: "customer_code", isRequired: true, fastpath: "customers", isReadOnly: "edit", hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "customer_display" }),
    ...controls.magicDateLabel({ tab: "general", label: "Open Date", target: "open_date", star: false }),
    ...controls.magicDate({ tab: "general", name: "open_date", dateType: "ontype", isReadOnly: "edit", isReadOnly: true, default: 'sessiondate' }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.magicDateLabel({ tab: "general", label: "Close Date", target: "close_date", star: false }),
    ...controls.magicDate({ tab: "general", name: "close_date", dateType: "ontype", isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Freeze Type", star: false }),
    ...controls.autoComplete({ tab: "general", name: "freeze_type_code", width: "col-sm-2", controlType: "FreezeType", isReadOnly: true }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Mode of Operation", star: false }),
    ...controls.autoComplete({ tab: "general", name: "mode_of_operation_code", width: "col-sm-2", controlType: "ModeOfOperation" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Mobile Sms", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "mobile_sms", maxlength: 13, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Mobile Call", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "mobile_call", maxlength: 13, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Email", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "email", maxlength: 50, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Guardian Customer ID", star: false }),
    ...controls.oc({ tab: "general", c: "Customer", placeHolder: "Guardian Customer ID", name: "guardian_customer_code", fastpath: "customers", isReadOnly: "edit", hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "guardian_customer_display" }),
    ...controls.displayText({ tab: "general", label: "Referrer Customer ID", star: false }),
    ...controls.oc({ tab: "general", c: "Customer", placeHolder: "Referrer Customer ID", name: "referrer_customer_code", fastpath: "customers", isReadOnly: "edit", hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "referrer_customer_display" }),
    ...controls.checkBox({ tab: "general", label: "Senior Citizen", default: false, name: "senior_citizen", isReadOnly: "edit" }),
    ...controls.checkBox({ tab: "general", label: "Is Staff", default: false, name: "is_staff", isReadOnly: "edit" }),
    ...controls.checkBox({ tab: "general", label: "Is Society", default: false, name: "is_society", isReadOnly: "edit" }),
    ...controls.magicDateLabel({ tab: "ac_loan_info", label: "Sanction Date", target: "ac_loan_info.sanction_date", star: true }),
    ...controls.magicDate({ tab: "ac_loan_info", name: "ac_loan_info.sanction_date", dateType: "ontype", isRequired: true }),
    ...controls.displayText({ tab: "ac_loan_info", label: "" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Sanction Amount" }),
    ...controls.floatOnly({ tab: "ac_loan_info", placeHolder: "", name: "ac_loan_info.sanction_amount", maxlength: 18 }),
    ...controls.displayText({ tab: "ac_loan_info", label: "" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Sanction Letter No", star: false }),
    ...controls.text({ tab: "ac_loan_info", placeHolder: "", name: "ac_loan_info.sanction_letter_no", maxlength: 20, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Sanction By", star: false }),
    ...controls.autoComplete({ tab: "ac_loan_info", name: "ac_loan_info.loan_sanctioner_type_code", width: "col-sm-2", controlType: "LoanSanctionerType" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Disbursed Amount" }),
    ...controls.floatOnly({ tab: "ac_loan_info", placeHolder: "", name: "ac_loan_info.disb_amount", maxlength: 18, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "ac_loan_info", label: "" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Purpose", star: false }),
    ...controls.oc({ tab: "ac_loan_info", c: "Purpose", placeHolder: "Purpose Code", name: "ac_loan_info.purpose_code", fastpath: "purposes", hidden: false }),
    ...controls.showData({ tab: "ac_loan_info", displaytype: "capital", data: "ac_loan_info.purpose_display" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Priority Segment", star: false }),
    ...controls.oc({ tab: "ac_loan_info", c: "Priority", placeHolder: "Priority Segment", name: "ac_loan_info.priority_code", fastpath: "priorities", hidden: false }),
    ...controls.showData({ tab: "ac_loan_info", displaytype: "capital", data: "ac_loan_info.priority_display" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Priority Sector", star: false }),
    ...controls.oc({ tab: "ac_loan_info", c: "PrioritySector", placeHolder: "Priority Sector Code", name: "ac_loan_info.priority_sector_code", fastpath: "priority_sectors", hidden: false }),
    ...controls.showData({ tab: "ac_loan_info", displaytype: "capital", data: "ac_loan_info.priority_sector_display" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Loan Health Type", star: false }),
    ...controls.oc({ tab: "ac_loan_info", c: "LoanHealthType", placeHolder: "Loan Health Type Code", name: "ac_loan_info.loan_health_type_code", fastpath: "loan_health_types", hidden: false }),
    ...controls.showData({ tab: "ac_loan_info", displaytype: "capital", data: "ac_loan_info.loan_health_type_display" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Loan Category", star: false }),
    ...controls.autoComplete({ tab: "ac_loan_info", name: "ac_loan_info.loan_category_code", width: "col-sm-2", controlType: "LoanCategory" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Industry Type", star: false }),
    ...controls.autoComplete({ tab: "ac_loan_info", name: "ac_loan_info.industry_type_code", width: "col-sm-2", controlType: "IndustryType" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "ac_loan_info", label: "Is Secured", default: false, name: "ac_loan_info.is_secured", width: "col-sm-4" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "ac_loan_info", label: "Is related to director", default: false, name: "ac_loan_info.is_relative_director", width: "col-sm-4" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "Relation", star: false, parents: [{ "name": "ac_loan_info.is_relative_director", "match": "exist" }] }),
    ...controls.autoComplete({ tab: "ac_loan_info", name: "ac_loan_info.relation_code", width: "col-sm-2", controlType: "Relation" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "" }),
    ...controls.displayText({ tab: "ac_loan_info", label: "director customer id", star: false, parents: [{ "name": "ac_loan_info.is_relative_director", "match": "exist" }] }),
    ...controls.oc({ tab: "ac_loan_info", c: "Customer", placeHolder: "director customer id", name: "ac_loan_info.director_customer_code", fastpath: "customers", parents: [{ "name": "ac_loan_info.is_relative_director", "match": "exist" }], hidden: false }),
    ...controls.showData({ tab: "ac_loan_info", displaytype: "capital", data: "ac_loan_info.director_customer_display", parents: [{ "name": "ac_loan_info.is_relative_director", "match": "exist" }] }),
    ...controls.displayText({ tab: "term_deposit", label: "Scheme", star: true }),
    ...controls.autoComplete({
      tab: "term_deposit", name: "term_deposit.scheme_code", width: "col-sm-2", controlType: "Scheme",
      // sendToServer: { sendData: [{ varname: 'product_type.product_type_uid', value: 'product_type_uid' }, { varname: 'is_senior', value: 'senior_citizen' }] } 

    }),
    ...controls.displayText({ tab: "term_deposit", label: "" }),
    ...controls.displayText({ tab: "term_deposit", label: "Receipt No", star: false }),
    ...controls.text({ tab: "term_deposit", placeHolder: "", name: "term_deposit.receipt_no", maxlength: 20, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "term_deposit", label: "" }),
    ...controls.magicDateLabel({ tab: "term_deposit", label: "As On Date", target: "term_deposit.as_on_date", star: false }),
    ...controls.magicDate({ tab: "term_deposit", name: "term_deposit.as_on_date", dateType: "ontype", isReadOnly: "edit", default: 'n', isReadOnly: true }),
    ...controls.displayText({ tab: "term_deposit", label: "" }),
    ...controls.displayText({ tab: "term_deposit", label: "Deposit Amount" }),
    ...controls.floatOnly({ tab: "term_deposit", placeHolder: "", name: "term_deposit.deposit_amount", width: 'col-sm-2', maxlength: 18, isReadOnly: "edit", textwidth: "col-sm-2" }),
    ...controls.displayText({ tab: "term_deposit", label: "" }),
    ...controls.displayText({ tab: "term_deposit", label: "Period Months", star: false, parents: [{ "name": "interest_frequency_display", "match": "in", "reverse": "true", "value": ["Daily"] }] }),
    ...controls.numberOnly({ tab: "term_deposit", placeHolder: "", name: "term_deposit.period_months", maxlength: 200, parents: [{ "name": "interest_frequency_display", "match": "in", "reverse": "true", "value": ["Daily"] }], isReadOnly: "edit" }),
    ...controls.displayText({ tab: "term_deposit", label: "" }),
    ...controls.displayText({ tab: "term_deposit", label: "Period Days", star: false, parents: [{ "name": "interest_frequency_display", "match": "in", "value": ["Daily"] }] }),
    ...controls.numberOnly({ tab: "term_deposit", placeHolder: "", name: "term_deposit.period_days", maxlength: 200, parents: [{ "name": "interest_frequency_display", "match": "in", "value": ["Daily"] }], isReadOnly: "edit" }),
    ...controls.displayText({ tab: "term_deposit", label: "" }),
    ...controls.checkBox({ tab: "term_deposit", label: "Is Auto Renew", default: false, name: "term_deposit.is_auto_renew", isReadOnly: "edit" }),
    ...controls.checkBox({ tab: "term_deposit", label: "Auto Renew with Interest", default: false, name: "term_deposit.is_auto_renew_w_interest", parents: [{ "name": "term_deposit.is_auto_renew", "match": "exist", "show": "readonly" }], isReadOnly: "edit" }),
    ...controls.displayText({ tab: "term_deposit", label: "Maturity Int Ac", star: false, parents: [{ "name": "term_deposit.is_auto_renew", "match": "exist", "show": "readonly" }] }),
    ...controls.oc({ tab: "term_deposit", c: "Account", placeHolder: "Maturity Int Ac", name: "term_deposit.mat_int_account_code", fastpath: "accounts", parents: [{ "name": "term_deposit.is_auto_renew", "match": "exist", "show": "readonly" }], isReadOnly: "edit", hidden: false }),
    ...controls.showData({ tab: "term_deposit", displaytype: "capital", data: "term_deposit.mat_int_account_display", parents: [{ "name": "term_deposit.is_auto_renew", "match": "exist", "show": "readonly" }] }),
    ...controls.displayText({ tab: "term_deposit", label: "Standing Int Ac", star: false }),
    ...controls.oc({ tab: "term_deposit", c: "Account", placeHolder: "Standing Int Ac", name: "term_deposit.std_int_account_code", fastpath: "accounts", isReadOnly: "edit", displayData: { account_display: "term_deposit.std_int_account_display" }, hidden: false }),
    ...controls.showData({ tab: "term_deposit", displaytype: "capital", data: "term_deposit.std_int_account_display" }),
    ...controls.displayText({ tab: "term_deposit", label: "Maturity Amount" }),
    ...controls.floatOnly({ tab: "term_deposit", placeHolder: "", name: "term_deposit.maturity_amount", width: 'col-sm-2', maxlength: 18, isReadOnly: "edit", textwidth: "col-sm-2", isReadOnly: true }),
    ...controls.displayText({ tab: "term_deposit", label: "" }),
    ...controls.displayText({ tab: "term_deposit", label: "Interest Rate" }),
    ...controls.floatOnly({ tab: "term_deposit", placeHolder: "", name: "term_deposit.interest_rate", maxlength: 6, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "term_deposit", label: "" }),
    ...controls.displayText({ tab: "term_deposit", label: "Interest Payable" }),
    ...controls.floatOnly({ tab: "term_deposit", placeHolder: "", name: "term_deposit.interest_payable", maxlength: 18, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "term_deposit", label: "" }),
    ...controls.magicDateLabel({ tab: "term_deposit", label: "Maturity Date", target: "term_deposit.maturity_date", star: false }),
    ...controls.magicDate({ tab: "term_deposit", name: "term_deposit.maturity_date", dateType: "ontype", isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "term_deposit", label: "" }),
    {
      widths: "col-sm-12",
      tab: "term_deposit",
      title: "Td Schedule",
      subComponents: [
        ...controls.displayText({ tab: "td_schedule", width: "col-sm-12", label: "" }),
        ...controls.displayText({ tab: "td_schedule", width: "col-sm-4", label: "" }),
        ...controls.displayText({ tab: "td_schedule", width: "col-sm-1", label: "" }),
        ...controls.button({
          tab: "td_schedule",
          label: "Generate",
          style: { padding: 0 },
          Bcolor: "success",
          onclick: {
            action: "generateTDSchedule",
            acttype: "serverfunc",
            otherdata: ["product_uid", "term_deposit.scheme_uid", "term_deposit.as_on_date", "term_deposit.interest_frequency_uid", "term_deposit.deposit_amount", "term_deposit.period_months", "term_deposit.period_days", "term_deposit.is_auto_renew", "term_deposit.std_int_account_uid"],
            tableNameField: "td_schedule",
            requiredField: ["interest_date", "days", "months", "amount",],
            required: ["interest_date", "days", "months", "amount",],
          }, width: "col-sm-2"
        }),
        {
          tab: "td_schedule",
          inputType: "table",
          tableTitle: "",
          deletable: false,
          editable: false,
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Interest Date", field: "interest_date", displaytype: "date" },
            { label: "Days", field: "days" },
            { label: "Months", field: "months" },
            { label: "Amount", field: "amount" },
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          name: "td_schedule"
        },
      ]
    },
    ...controls.magicDateLabel({ tab: "recurring_deposit", label: "As On Date", target: "recurring_deposit.as_on_date", star: false }),
    ...controls.magicDate({ tab: "recurring_deposit", name: "recurring_deposit.as_on_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "recurring_deposit", label: "" }),
    ...controls.displayText({ tab: "recurring_deposit", label: "Installment Amount" }),
    ...controls.floatOnly({ tab: "recurring_deposit", placeHolder: "", name: "recurring_deposit.installment_amount", maxlength: 14 }),
    ...controls.displayText({ tab: "recurring_deposit", label: "" }),
    ...controls.displayText({ tab: "recurring_deposit", label: "Number Of Installments", star: false }),
    ...controls.numberOnly({ tab: "recurring_deposit", placeHolder: "", name: "recurring_deposit.number_of_installments", maxlength: 200 }),
    ...controls.displayText({ tab: "recurring_deposit", label: "" }),
    {
      widths: "col-sm-12",
      tab: "recurring_deposit",
      title: "Rd Schedule",
      subComponents: [
        ...controls.displayText({ tab: "rd_schedule", width: "col-sm-12", label: "" }),
        ...controls.displayText({ tab: "rd_schedule", width: "col-sm-4", label: "" }),
        ...controls.displayText({ tab: "rd_schedule", width: "col-sm-1", label: "" }),
        ...controls.button({
          tab: "rd_schedule",
          label: "Generate",
          style: { padding: 0 },
          Bcolor: "success",
          onclick: {
            action: "generateRDSchedule",
            acttype: "serverfunc",
            otherdata: ["product_uid", "recurring_deposit.as_on_date", "recurring_deposit.deposit_amount", "recurring_deposit.number_of_installments"],
            tableNameField: "rd_schedule",
            requiredField: ["interest_date", "days", "months", "amount",],
            required: ["interest_date", "days", "months", "amount",],
          }, width: "col-sm-2"
        }),
        {
          tab: "rd_schedule",
          inputType: "table",
          tableTitle: "",
          deletable: false,
          editable: false,
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Interest Date", field: "interest_date", displaytype: "date" },
            { label: "Days", field: "days" },
            { label: "Months", field: "months" },
            { label: "Amount", field: "amount" },
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          name: "rd_schedule"
        },
      ]
    },
    ...controls.displayText({ tab: "pigmy_deposit", label: "Scheme", star: false }),
    ...controls.autoComplete({ tab: "pigmy_deposit", name: "pigmy_deposit.scheme_code", width: "col-sm-2", controlType: "Scheme" }),
    ...controls.displayText({ tab: "pigmy_deposit", label: "" }),
    ...controls.magicDateLabel({ tab: "pigmy_deposit", label: "As On Date", target: "pigmy_deposit.as_on_date", star: false }),
    ...controls.magicDate({ tab: "pigmy_deposit", name: "pigmy_deposit.as_on_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "pigmy_deposit", label: "" }),
    ...controls.displayText({ tab: "pigmy_deposit", label: "Installment Amount" }),
    ...controls.floatOnly({ tab: "pigmy_deposit", placeHolder: "", name: "pigmy_deposit.installment_amount", maxlength: 14 }),
    ...controls.displayText({ tab: "pigmy_deposit", label: "" }),
    ...controls.magicDateLabel({ tab: "account_installment", label: "As On Date", target: "account_installment.as_on_date", star: false }),
    ...controls.magicDate({ tab: "account_installment", name: "account_installment.as_on_date", dateType: "ontype", isReadOnly: "edit", default: 'n', isReadOnly: true }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    ...controls.magicDateLabel({ tab: "account_installment", label: "First Installment Date", target: "account_installment.first_installment_date", star: true }),
    ...controls.magicDate({ tab: "account_installment", name: "account_installment.first_installment_date", dateType: "ontype", isRequired: true, isReadOnly: "edit", minDate: 't' }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    ...controls.displayText({ tab: "account_installment", label: "Number Of Installments", star: true }),
    ...controls.numberOnly({ tab: "account_installment", placeHolder: "", name: "account_installment.number_of_installments", isRequired: true, maxlength: 200, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    ...controls.displayText({ tab: "account_installment", label: "Installment Frequency", star: true }),
    ...controls.autoComplete({ tab: "account_installment", name: "account_installment.installment_frequency_code", width: "col-sm-2", controlType: "InstallmentFrequency" }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    ...controls.displayText({ tab: "account_installment", label: "Account", star: false }),
    ...controls.oc({ tab: "account_installment", c: "Account", placeHolder: "Account Code", name: "account_installment.account_code", fastpath: "accounts", isReadOnly: "edit", hidden: false }),
    ...controls.showData({ tab: "account_installment", displaytype: "capital", data: "account_installment.account_display" }),
    ...controls.displayText({ tab: "account_installment", label: "Moratorium Period", star: false }),
    ...controls.numberOnly({ tab: "account_installment", placeHolder: "", name: "account_installment.moratorium_period", maxlength: 200, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    ...controls.displayText({ tab: "account_installment", label: "Installment Amount" }),
    ...controls.floatOnly({ tab: "account_installment", placeHolder: "", name: "account_installment.installment_amount", maxlength: 18, isReadOnly: "edit" }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    ...controls.displayText({ tab: "account_installment", label: "Interest Rate" }),
    ...controls.floatOnly({ tab: "account_installment", placeHolder: "", name: "account_installment.interest_rate", maxlength: 6, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    ...controls.displayText({ tab: "account_installment", label: "Total Interest" }),
    ...controls.floatOnly({ tab: "account_installment", placeHolder: "", name: "account_installment.total_interest", maxlength: 18, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    ...controls.displayText({ tab: "account_installment", label: "Principal + Interest" }),
    ...controls.floatOnly({ tab: "account_installment", placeHolder: "", name: "account_installment.total_recoverable_amount", maxlength: 18, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    ...controls.magicDateLabel({ tab: "account_installment", label: "Expiry Date", target: "account_installment.expiry_date", star: true }),
    ...controls.magicDate({ tab: "account_installment", name: "account_installment.expiry_date", dateType: "ontype", isRequired: true, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    ...controls.displayText({ tab: "account_installment", label: "installment_type", star: false }),
    ...controls.text({ tab: "account_installment", placeHolder: "", name: "account_installment.installment_type", maxlength: 20, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "account_installment", label: "" }),
    {
      widths: "col-sm-12",
      tab: "account_installment",
      title: "Account Installment Schedule",
      subComponents: [
        ...controls.displayText({ tab: "account_installment_schedule", width: "col-sm-12", label: "" }),
        ...controls.displayText({ tab: "account_installment_schedule", width: "col-sm-4", label: "" }),
        ...controls.displayText({ tab: "account_installment_schedule", width: "col-sm-1", label: "" }),
        ...controls.button({
          tab: "account_installment_schedule",
          label: "Generate",
          style: { padding: 0 },
          Bcolor: "success",
          onclick: {
            action: "generateLoanSchedule",
            acttype: "serverfunc",
            otherdata: ["product_uid", "ac_loan_info.sanction_amount", "account_installment.first_installment_date", "account_installment.installment_amount", "account_installment.number_of_installments", "account_installment.installment_frequency_uid", "account_installment.installment_type_uid", "account_installment.moratorium_period"],
            tableNameField: "account_installment_schedule",
            requiredField: ["installment_number", "installment_date", "principal_amount", "interest_amount", "total", "required_balance", "os_balance", "overdue", "os_interest", "calcinterest",],
            required: ["installment_date",],
          }, width: "col-sm-2"
        }),
        {
          tab: "account_installment_schedule",
          inputType: "table",
          tableTitle: "",
          deletable: false,
          editable: false,
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Installment Number", field: "installment_number" },
            { label: "Installment Date", field: "installment_date", displaytype: "date" },
            { label: "Principal Amount", field: "principal_amount" },
            { label: "Interest Amount", field: "interest_amount" },
            { label: "Total", field: "total" },
            { label: "Required Balance", field: "required_balance" },
            { label: "Os Balance", field: "os_balance" },
            { label: "Overdue", field: "overdue" },
            { label: "Os Interest", field: "os_interest" },
            { label: "Calcinterest", field: "calcinterest" },
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          name: "account_installment_schedule"
        },
      ]
    },
    ...controls.displayText({ tab: "ac_nominees", label: "Full Name", star: true }),
    ...controls.text({ tab: "ac_nominees", placeHolder: "", name: "full_name", width: "col-sm-4", maxlength: 100 }),
    ...controls.magicDateLabel({ tab: "ac_nominees", label: "Date of Birth", target: "dob", star: false }),
    ...controls.magicDate({ tab: "ac_nominees", name: "dob", dateType: "ontype", maxDate: 'y' }),
    ...controls.displayText({ tab: "ac_nominees", label: "" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Age", star: true }),
    ...controls.numberOnly({ tab: "ac_nominees", placeHolder: "", name: "age", maxlength: 200 }),
    ...controls.displayText({ tab: "ac_nominees", label: "" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Share" }),
    ...controls.floatOnly({ tab: "ac_nominees", placeHolder: "", name: "share", maxlength: 6 }),
    ...controls.displayText({ tab: "ac_nominees", label: "" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Guardian Descn", star: false }),
    ...controls.text({ tab: "ac_nominees", placeHolder: "", name: "guardian_descn", maxlength: 50 }),
    ...controls.displayText({ tab: "ac_nominees", label: "" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Relation", star: true }),
    ...controls.autoComplete({ tab: "ac_nominees", name: "relation_code", width: "col-sm-2", controlType: "Relation" }),
    ...controls.displayText({ tab: "ac_nominees", label: "" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Nominee Doc Type", star: false }),
    ...controls.oc({ tab: "ac_nominees", c: "DocumentType", placeHolder: "Nominee Doc Type", name: "nominee_document_type_code", fastpath: "document_types", displayData: { document_type_display: "nominee_document_type_display", document_type_uid: "nominee_document_type_uid" }, hidden: false }),
    ...controls.showData({ tab: "ac_nominees", displaytype: "capital", data: "nominee_document_type_display" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Doc No", star: false }),
    ...controls.text({ tab: "ac_nominees", placeHolder: "", name: "nominee_document_no", maxlength: 50 }),
    ...controls.displayText({ tab: "ac_nominees", label: "" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Guardian Doc Type", star: false }),
    ...controls.oc({ tab: "ac_nominees", c: "DocumentType", placeHolder: "Guardian Doc Type", name: "guardian_document_type_code", fastpath: "document_types", displayData: { document_type_display: "guardian_document_type_display", document_type_uid: "guardian_document_type_uid" }, hidden: false }),
    ...controls.showData({ tab: "ac_nominees", displaytype: "capital", data: "guardian_document_type_display" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Doc No", star: false }),
    ...controls.text({ tab: "ac_nominees", placeHolder: "", name: "guardian_document_no", maxlength: 50 }),
    ...controls.displayText({ tab: "ac_nominees", label: "" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Nominee Phone", star: false }),
    ...controls.text({ tab: "ac_nominees", placeHolder: "", name: "nominee_phone", maxlength: 13 }),
    ...controls.displayText({ tab: "ac_nominees", label: "" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Guardian Phone", star: false }),
    ...controls.text({ tab: "ac_nominees", placeHolder: "", name: "guardian_phone", maxlength: 13 }),
    ...controls.displayText({ tab: "ac_nominees", label: "" }),
    ...controls.displayText({ tab: "ac_nominees", label: "Nominee Address", star: true }),
    ...controls.text({ tab: "ac_nominees", placeHolder: "", name: "nominee_address", width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "ac_nominees", label: "Guardian Address", star: false }),
    ...controls.text({ tab: "ac_nominees", placeHolder: "", name: "guardian_address", width: "col-sm-4", maxlength: 100 }),

    ...controls.displayText({ tab: "ac_nominees", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "ac_nominees", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "ac_nominees",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "ac_nominees",
        requiredField: ["full_name", "dob", "age", "share", "guardian_descn", "relation_code", "relation_display", "relation_uid", "document_type_code", "document_type_display", "document_type_uid", "nominee_document_no", "document_type_code", "document_type_display", "document_type_uid", "guardian_document_no", "nominee_phone", "guardian_phone", "nominee_address", "guardian_address",],
        required: ["full_name", "age", "relation_code", "relation_display", "relation_uid", "nominee_address",],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "ac_nominees",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "ac_nominees",
        requiredField: ["full_name", "dob", "age", "share", "guardian_descn", "relation_code", "relation_display", "relation_uid", "document_type_code", "document_type_display", "document_type_uid", "nominee_document_no", "document_type_code", "document_type_display", "document_type_uid", "guardian_document_no", "nominee_phone", "guardian_phone", "nominee_address", "guardian_address",]
      }, width: "col-sm-2"
    }),
    {
      tab: "ac_nominees",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Full Name", field: "full_name" },
        { label: "Date of Birth", field: "dob", displaytype: "date" },
        { label: "Age", field: "age" },
        { label: "Share", field: "share" },
        { label: "Guardian Descn", field: "guardian_descn" },
        { label: "Relation Code", field: "relation_code" },
        { label: "Relation ", field: "relation_display" },
        { label: "Document Type Code", field: "document_type_code" },
        { label: "Nominee Doc Type", field: "document_type_display" },
        { label: "Doc No", field: "nominee_document_no" },
        { label: "Document Type Code", field: "document_type_code" },
        { label: "Guardian Doc Type", field: "document_type_display" },
        { label: "Doc No", field: "guardian_document_no" },
        { label: "Nominee Phone", field: "nominee_phone" },
        { label: "Guardian Phone", field: "guardian_phone" },
        { label: "Nominee Address", field: "nominee_address" },
        { label: "Guardian Address", field: "guardian_address" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "ac_nominees"
    },
    ...controls.displayText({ tab: "account_joints", label: "Customer", star: false }),
    ...controls.oc({ tab: "account_joints", c: "Customer", placeHolder: "Customer Code", name: "customer_code", fastpath: "customers", isReadOnly: "edit", hidden: false }),
    ...controls.showData({ tab: "account_joints", displaytype: "capital", data: "customer_display" }),
    ...controls.magicDateLabel({ tab: "account_joints", label: "Given Date", target: "given_date", star: false }),
    ...controls.magicDate({ tab: "account_joints", name: "given_date", dateType: "ontype", isReadOnly: "edit", default: 'sessiondate' }),
    ...controls.displayText({ tab: "account_joints", label: "" }),
    ...controls.magicDateLabel({ tab: "account_joints", label: "Upto Date", target: "upto_date", star: false }),
    ...controls.magicDate({ tab: "account_joints", name: "upto_date", dateType: "ontype", isReadOnly: "edit", minDate: 'session_date' }),
    ...controls.displayText({ tab: "account_joints", label: "" }),
    ...controls.displayText({ tab: "account_joints", label: "Joint Type", star: false }),
    ...controls.autoComplete({ tab: "account_joints", name: "joint_type_code", width: "col-sm-2", controlType: "JointType" }),
    ...controls.displayText({ tab: "account_joints", label: "" }),
    ...controls.checkBox({ tab: "account_joints", label: "Is sign required?", default: false, name: "sign_reqd", isReadOnly: "edit" }),

    ...controls.displayText({ tab: "account_joints", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "account_joints", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "account_joints",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "account_joints",
        requiredField: ["customer_code", "customer_display", "customer_uid", "given_date", "upto_date", "joint_type_code", "joint_type_display", "joint_type_uid", "sign_reqd",],
        required: [],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "account_joints",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "account_joints",
        requiredField: ["customer_code", "customer_display", "customer_uid", "given_date", "upto_date", "joint_type_code", "joint_type_display", "joint_type_uid", "sign_reqd",]
      }, width: "col-sm-2"
    }),
    {
      tab: "account_joints",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Customer Code", field: "customer_code" },
        { label: "Customer ", field: "customer_display" },
        { label: "Given Date", field: "given_date", displaytype: "date" },
        { label: "Upto Date", field: "upto_date", displaytype: "date" },
        { label: "Joint Type Code", field: "joint_type_code" },
        { label: "Joint Type", field: "joint_type_display" },
        { label: "Is sign required?", field: "sign_reqd", displaytype: "tick" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "account_joints"
    },
    ...controls.displayText({ tab: "account_guarantors", label: "Guarantor Customer ID", star: true }),
    ...controls.oc({ tab: "account_guarantors", c: "Customer", placeHolder: "Guarantor Customer ID", name: "customer_code", fastpath: "customers", hidden: false }),
    ...controls.showData({ tab: "account_guarantors", displaytype: "capital", data: "customer_display" }),
    ...controls.displayText({ tab: "account_guarantors", label: "Percentage", star: false }),
    ...controls.numberOnly({ tab: "account_guarantors", placeHolder: "", name: "percentage", maxlength: 200, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "account_guarantors", label: "" }),
    ...controls.displayText({ tab: "account_guarantors", label: "Amount" }),
    ...controls.floatOnly({ tab: "account_guarantors", placeHolder: "", name: "amount", maxlength: 18, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "account_guarantors", label: "" }),

    ...controls.displayText({ tab: "account_guarantors", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "account_guarantors", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "account_guarantors",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "account_guarantors",
        requiredField: ["customer_code", "customer_display", "customer_uid", "percentage", "amount",],
        required: ["customer_code", "customer_display", "customer_uid",],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "account_guarantors",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "account_guarantors",
        requiredField: ["customer_code", "customer_display", "customer_uid", "percentage", "amount",]
      }, width: "col-sm-2"
    }),
    {
      tab: "account_guarantors",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Customer Code", field: "customer_code" },
        { label: "Guarantor Customer ID", field: "customer_display" },
        { label: "Percentage", field: "percentage" },
        { label: "Amount", field: "amount" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "account_guarantors"
    },
    ...controls.displayText({ tab: "account_insurances", label: "Insurance Company", star: true }),
    ...controls.autoComplete({ tab: "account_insurances", name: "insurance_company_code", width: "col-sm-2", controlType: "InsuranceCompany" }),
    ...controls.displayText({ tab: "account_insurances", label: "" }),
    ...controls.displayText({ tab: "account_insurances", label: "Insurance Type", star: false }),
    ...controls.autoComplete({ tab: "account_insurances", name: "insurance_type_code", width: "col-sm-2", controlType: "InsuranceType" }),
    ...controls.displayText({ tab: "account_insurances", label: "" }),
    ...controls.displayText({ tab: "account_insurances", label: "Policy Number", star: false }),
    ...controls.numberOnly({ tab: "account_insurances", placeHolder: "", name: "policy_number", maxlength: 200 }),
    ...controls.displayText({ tab: "account_insurances", label: "" }),
    ...controls.magicDateLabel({ tab: "account_insurances", label: "Policy Start Date", target: "policy_start_date", star: false }),
    ...controls.magicDate({ tab: "account_insurances", name: "policy_start_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "account_insurances", label: "" }),
    ...controls.magicDateLabel({ tab: "account_insurances", label: "Policy End Date", target: "policy_end_date", star: false }),
    ...controls.magicDate({ tab: "account_insurances", name: "policy_end_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "account_insurances", label: "" }),
    ...controls.displayText({ tab: "account_insurances", label: "Insured Amount", star: true }),
    ...controls.numberOnly({ tab: "account_insurances", placeHolder: "", name: "insured_amount", maxlength: 200 }),
    ...controls.displayText({ tab: "account_insurances", label: "" }),
    ...controls.displayText({ tab: "account_insurances", label: "Premium Amount", star: true }),
    ...controls.numberOnly({ tab: "account_insurances", placeHolder: "", name: "premium_amount", maxlength: 200 }),
    ...controls.displayText({ tab: "account_insurances", label: "" }),

    ...controls.displayText({ tab: "account_insurances", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "account_insurances", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "account_insurances",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "account_insurances",
        requiredField: ["insurance_company_code", "insurance_company_display", "insurance_company_uid", "insurance_type_code", "insurance_type_display", "insurance_type_uid", "policy_number", "policy_start_date", "policy_end_date", "insured_amount", "premium_amount",],
        required: ["insurance_company_code", "insurance_company_display", "insurance_company_uid", "insured_amount", "premium_amount",],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "account_insurances",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "account_insurances",
        requiredField: ["insurance_company_code", "insurance_company_display", "insurance_company_uid", "insurance_type_code", "insurance_type_display", "insurance_type_uid", "policy_number", "policy_start_date", "policy_end_date", "insured_amount", "premium_amount",]
      }, width: "col-sm-2"
    }),
    {
      tab: "account_insurances",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Insurance Company Code", field: "insurance_company_code" },
        { label: "Insurance Company ", field: "insurance_company_display" },
        { label: "Insurance Type Code", field: "insurance_type_code" },
        { label: "Insurance Type ", field: "insurance_type_display" },
        { label: "Policy Number", field: "policy_number" },
        { label: "Policy Start Date", field: "policy_start_date", displaytype: "date" },
        { label: "Policy End Date", field: "policy_end_date", displaytype: "date" },
        { label: "Insured Amount", field: "insured_amount" },
        { label: "Premium Amount", field: "premium_amount" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "account_insurances"
    },
    ...controls.displayText({ tab: "account_gold_details", label: "Gold Ornament Type", star: false }),
    ...controls.oc({ tab: "account_gold_details", c: "GoldOrnamentType", placeHolder: "Gold Ornament Type Code", name: "gold_ornament_type_code", fastpath: "gold_ornament_types", hidden: false }),
    ...controls.showData({ tab: "account_gold_details", displaytype: "capital", data: "gold_ornament_type_display" }),
    ...controls.displayText({ tab: "account_gold_details", label: "Valuator", star: false }),
    ...controls.oc({ tab: "account_gold_details", c: "Valuator", placeHolder: "Valuator Code", name: "valuator_code", fastpath: "valuators", hidden: false }),
    ...controls.showData({ tab: "account_gold_details", displaytype: "capital", data: "valuator_display" }),
    ...controls.displayText({ tab: "account_gold_details", label: "Quantity", star: false }),
    ...controls.numberOnly({ tab: "account_gold_details", placeHolder: "", name: "quantity", maxlength: 200 }),
    ...controls.displayText({ tab: "account_gold_details", label: "" }),
    ...controls.displayText({ tab: "account_gold_details", label: "Descn", star: false }),
    ...controls.text({ tab: "account_gold_details", placeHolder: "", name: "descn", width: "col-sm-4", maxlength: 200 }),
    ...controls.displayText({ tab: "account_gold_details", label: "Gross Weight" }),
    ...controls.floatOnly({ tab: "account_gold_details", placeHolder: "", name: "gross_weight", maxlength: 10 }),
    ...controls.displayText({ tab: "account_gold_details", label: "" }),
    ...controls.displayText({ tab: "account_gold_details", label: "Net Weight" }),
    ...controls.floatOnly({ tab: "account_gold_details", placeHolder: "", name: "net_weight", maxlength: 10 }),
    ...controls.displayText({ tab: "account_gold_details", label: "" }),
    ...controls.displayText({ tab: "account_gold_details", label: "Gold Rate" }),
    ...controls.floatOnly({ tab: "account_gold_details", placeHolder: "", name: "gold_rate", maxlength: 8 }),
    ...controls.displayText({ tab: "account_gold_details", label: "" }),
    ...controls.magicDateLabel({ tab: "account_gold_details", label: "Returned On", target: "returned_on", star: false }),
    ...controls.magicDate({ tab: "account_gold_details", name: "returned_on", dateType: "ontype" }),
    ...controls.displayText({ tab: "account_gold_details", label: "" }),
    ...controls.displayText({ tab: "account_gold_details", label: "Receipt Number", star: false }),
    ...controls.text({ tab: "account_gold_details", placeHolder: "", name: "receipt_number", maxlength: 10 }),
    ...controls.displayText({ tab: "account_gold_details", label: "" }),

    ...controls.displayText({ tab: "account_gold_details", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "account_gold_details", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "account_gold_details",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "account_gold_details",
        requiredField: ["gold_ornament_type_code", "gold_ornament_type_display", "gold_ornament_type_uid", "valuator_code", "valuator_display", "valuator_uid", "quantity", "descn", "gross_weight", "net_weight", "gold_rate", "returned_on", "receipt_number",],
        required: ["gross_weight", "net_weight", "gold_rate",],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "account_gold_details",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "account_gold_details",
        requiredField: ["gold_ornament_type_code", "gold_ornament_type_display", "gold_ornament_type_uid", "valuator_code", "valuator_display", "valuator_uid", "quantity", "descn", "gross_weight", "net_weight", "gold_rate", "returned_on", "receipt_number",]
      }, width: "col-sm-2"
    }),
    {
      tab: "account_gold_details",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Gold Ornament Type Code", field: "gold_ornament_type_code" },
        { label: "Gold Ornament Type ", field: "gold_ornament_type_display" },
        { label: "Valuator Code", field: "valuator_code" },
        { label: "Valuator ", field: "valuator_display" },
        { label: "Quantity", field: "quantity" },
        { label: "Descn", field: "descn" },
        { label: "Gross Weight", field: "gross_weight" },
        { label: "Net Weight", field: "net_weight" },
        { label: "Gold Rate", field: "gold_rate" },
        { label: "Returned On", field: "returned_on", displaytype: "date" },
        { label: "Receipt Number", field: "receipt_number" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "account_gold_details"
    },
    ...controls.displayText({ tab: "account_vehicle_details", label: "Vehicle Type", star: false }),
    ...controls.oc({ tab: "account_vehicle_details", c: "VehicleType", placeHolder: "Vehicle Type Code", name: "vehicle_type_code", fastpath: "vehicle_types", hidden: false }),
    ...controls.showData({ tab: "account_vehicle_details", displaytype: "capital", data: "vehicle_type_display" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "Vehicle Brand", star: false }),
    ...controls.oc({ tab: "account_vehicle_details", c: "VehicleBrand", placeHolder: "Vehicle Brand Code", name: "vehicle_brand_code", fastpath: "vehicle_brands", hidden: false }),
    ...controls.showData({ tab: "account_vehicle_details", displaytype: "capital", data: "vehicle_brand_display" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "Vehicle Model", star: false }),
    ...controls.oc({ tab: "account_vehicle_details", c: "VehicleModel", placeHolder: "Vehicle Model Code", name: "vehicle_model_code", fastpath: "vehicle_models", hidden: false }),
    ...controls.showData({ tab: "account_vehicle_details", displaytype: "capital", data: "vehicle_model_display" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "Vendor", star: false }),
    ...controls.oc({ tab: "account_vehicle_details", c: "Vendor", placeHolder: "Vendor Code", name: "vendor_code", fastpath: "vendors", hidden: false }),
    ...controls.showData({ tab: "account_vehicle_details", displaytype: "capital", data: "vendor_display" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "Valuator", star: false }),
    ...controls.oc({ tab: "account_vehicle_details", c: "Valuator", placeHolder: "Valuator Code", name: "valuator_code", fastpath: "valuators", hidden: false }),
    ...controls.showData({ tab: "account_vehicle_details", displaytype: "capital", data: "valuator_display" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "Engine Cc", star: true }),
    ...controls.numberOnly({ tab: "account_vehicle_details", placeHolder: "", name: "engine_cc", maxlength: 200 }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "Chasis Number", star: true }),
    ...controls.text({ tab: "account_vehicle_details", placeHolder: "", name: "chasis_number", maxlength: 20 }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "Ex Showroom Price" }),
    ...controls.floatOnly({ tab: "account_vehicle_details", placeHolder: "", name: "ex_showroom_price", maxlength: 10 }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "Sale Price" }),
    ...controls.floatOnly({ tab: "account_vehicle_details", placeHolder: "", name: "sale_price", maxlength: 10 }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "License Number", star: false }),
    ...controls.text({ tab: "account_vehicle_details", placeHolder: "", name: "license_number", maxlength: 20 }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "Vehicle Number", star: false }),
    ...controls.text({ tab: "account_vehicle_details", placeHolder: "", name: "vehicle_number", maxlength: 12 }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "" }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "Invoice Number", star: false }),
    ...controls.text({ tab: "account_vehicle_details", placeHolder: "", name: "invoice_number", maxlength: 20 }),
    ...controls.displayText({ tab: "account_vehicle_details", label: "" }),

    ...controls.displayText({ tab: "account_vehicle_details", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "account_vehicle_details", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "account_vehicle_details",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "account_vehicle_details",
        requiredField: ["vehicle_type_code", "vehicle_type_display", "vehicle_type_uid", "vehicle_brand_code", "vehicle_brand_display", "vehicle_brand_uid", "vehicle_model_code", "vehicle_model_display", "vehicle_model_uid", "vendor_code", "vendor_display", "vendor_uid", "valuator_code", "valuator_display", "valuator_uid", "engine_cc", "chasis_number", "ex_showroom_price", "sale_price", "license_number", "vehicle_number", "invoice_number",],
        required: ["engine_cc", "chasis_number",],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "account_vehicle_details",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "account_vehicle_details",
        requiredField: ["vehicle_type_code", "vehicle_type_display", "vehicle_type_uid", "vehicle_brand_code", "vehicle_brand_display", "vehicle_brand_uid", "vehicle_model_code", "vehicle_model_display", "vehicle_model_uid", "vendor_code", "vendor_display", "vendor_uid", "valuator_code", "valuator_display", "valuator_uid", "engine_cc", "chasis_number", "ex_showroom_price", "sale_price", "license_number", "vehicle_number", "invoice_number",]
      }, width: "col-sm-2"
    }),
    {
      tab: "account_vehicle_details",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Vehicle Type Code", field: "vehicle_type_code" },
        { label: "Vehicle Type ", field: "vehicle_type_display" },
        { label: "Vehicle Brand Code", field: "vehicle_brand_code" },
        { label: "Vehicle Brand ", field: "vehicle_brand_display" },
        { label: "Vehicle Model Code", field: "vehicle_model_code" },
        { label: "Vehicle Model ", field: "vehicle_model_display" },
        { label: "Vendor Code", field: "vendor_code" },
        { label: "Dealer ", field: "vendor_display" },
        { label: "Valuator Code", field: "valuator_code" },
        { label: "Valuator ", field: "valuator_display" },
        { label: "Engine Cc", field: "engine_cc" },
        { label: "Chasis Number", field: "chasis_number" },
        { label: "Ex Showroom Price", field: "ex_showroom_price" },
        { label: "Sale Price", field: "sale_price" },
        { label: "License Number", field: "license_number" },
        { label: "Vehicle Number", field: "vehicle_number" },
        { label: "Invoice Number", field: "invoice_number" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "account_vehicle_details"
    },
    ...controls.magicDateLabel({ tab: "account_lien_details", label: "Mark Date", target: "mark_date", star: true }),
    ...controls.magicDate({ tab: "account_lien_details", name: "mark_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "account_lien_details", label: "" }),
    ...controls.displayText({ tab: "account_lien_details", label: "Mark Fd Amount" }),
    ...controls.floatOnly({ tab: "account_lien_details", placeHolder: "", name: "mark_fd_amount", maxlength: 18 }),
    ...controls.displayText({ tab: "account_lien_details", label: "" }),
    ...controls.magicDateLabel({ tab: "account_lien_details", label: "Release Date", target: "release_date", star: true }),
    ...controls.magicDate({ tab: "account_lien_details", name: "release_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "account_lien_details", label: "" }),
    ...controls.displayText({ tab: "account_lien_details", label: "Mark By User", star: false }),
    ...controls.oc({ tab: "account_lien_details", c: "User", placeHolder: "Mark By User", name: "mark_by_code", fastpath: "users", hidden: false }),
    ...controls.showData({ tab: "account_lien_details", displaytype: "capital", data: "mark_by_display" }),
    ...controls.displayText({ tab: "account_lien_details", label: "Release By User", star: false }),
    ...controls.oc({ tab: "account_lien_details", c: "User", placeHolder: "Release By User", name: "release_by_code", fastpath: "users", hidden: false }),
    ...controls.showData({ tab: "account_lien_details", displaytype: "capital", data: "release_by_display" }),

    ...controls.displayText({ tab: "account_lien_details", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "account_lien_details", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "account_lien_details",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "account_lien_details",
        requiredField: ["mark_date", "mark_fd_amount", "release_date", "user_code", "user_display", "user_uid", "user_code", "user_display", "user_uid",],
        required: ["mark_date", "release_date",],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "account_lien_details",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "account_lien_details",
        requiredField: ["mark_date", "mark_fd_amount", "release_date", "user_code", "user_display", "user_uid", "user_code", "user_display", "user_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "account_lien_details",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Mark Date", field: "mark_date", displaytype: "date" },
        { label: "Mark Fd Amount", field: "mark_fd_amount" },
        { label: "Release Date", field: "release_date", displaytype: "date" },
        { label: "User Code", field: "user_code" },
        { label: "Mark By User", field: "user_display" },
        { label: "User Code", field: "user_code" },
        { label: "Release By User", field: "user_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "account_lien_details"
    },
    ...controls.magicDateLabel({ tab: "account_security_details", label: "Given Date", target: "given_date", star: true }),
    ...controls.magicDate({ tab: "account_security_details", name: "given_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "account_security_details", label: "" }),
    ...controls.displayText({ tab: "account_security_details", label: "Security", star: false }),
    ...controls.oc({ tab: "account_security_details", c: "Security", placeHolder: "Security Code", name: "security_code", fastpath: "securities", hidden: false }),
    ...controls.showData({ tab: "account_security_details", displaytype: "capital", data: "security_display" }),
    ...controls.displayText({ tab: "account_security_details", label: "Secured Value" }),
    ...controls.floatOnly({ tab: "account_security_details", placeHolder: "", name: "secured_value", maxlength: 18 }),
    ...controls.displayText({ tab: "account_security_details", label: "" }),
    ...controls.displayText({ tab: "account_security_details", label: "Description", star: false }),
    ...controls.text({ tab: "account_security_details", placeHolder: "", name: "description", maxlength: 50 }),
    ...controls.displayText({ tab: "account_security_details", label: "" }),
    ...controls.magicDateLabel({ tab: "account_security_details", label: "Release Date", target: "release_date", star: true }),
    ...controls.magicDate({ tab: "account_security_details", name: "release_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "account_security_details", label: "" }),
    ...controls.magicDateLabel({ tab: "account_security_details", label: "Security Expiry Date", target: "security_expiry_date", star: true }),
    ...controls.magicDate({ tab: "account_security_details", name: "security_expiry_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "account_security_details", label: "" }),

    ...controls.displayText({ tab: "account_security_details", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "account_security_details", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "account_security_details",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "account_security_details",
        requiredField: ["given_date", "security_code", "security_display", "security_uid", "secured_value", "description", "release_date", "security_expiry_date",],
        required: ["given_date", "release_date", "security_expiry_date",],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "account_security_details",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "account_security_details",
        requiredField: ["given_date", "security_code", "security_display", "security_uid", "secured_value", "description", "release_date", "security_expiry_date",]
      }, width: "col-sm-2"
    }),
    {
      tab: "account_security_details",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Given Date", field: "given_date", displaytype: "date" },
        { label: "Security Code", field: "security_code" },
        { label: "Security ", field: "security_display" },
        { label: "Secured Value", field: "secured_value" },
        { label: "Description", field: "description" },
        { label: "Release Date", field: "release_date", displaytype: "date" },
        { label: "Security Expiry Date", field: "security_expiry_date", displaytype: "date" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "account_security_details"
    },
    ...controls.displayText({ tab: "account_documents", label: "Document Type", star: false }),
    ...controls.oc({ tab: "account_documents", c: "DocumentType", placeHolder: "Document Type Code", name: "document_type_code", fastpath: "document_types", hidden: false }),
    ...controls.showData({ tab: "account_documents", displaytype: "capital", data: "document_type_display" }),
    ...controls.displayText({ tab: "account_documents", label: "Document Purpose", star: false }),
    ...controls.autoComplete({ tab: "account_documents", name: "document_purpose_code", width: "col-sm-2", controlType: "DocumentPurpose" }),
    ...controls.displayText({ tab: "account_documents", label: "" }),
    ...controls.displayText({ tab: "account_documents", label: "Doc No", star: false }),
    ...controls.text({ tab: "account_documents", placeHolder: "", name: "document_ref", maxlength: 36 }),
    ...controls.displayText({ tab: "account_documents", label: "" }),
    ...controls.magicDateLabel({ tab: "account_documents", label: "Doc Start Date", target: "doc_start_date", star: false }),
    ...controls.magicDate({ tab: "account_documents", name: "doc_start_date", dateType: "ontype", maxDate: 'n' }),
    ...controls.displayText({ tab: "account_documents", label: "" }),
    ...controls.magicDateLabel({ tab: "account_documents", label: "Doc End Date", target: "doc_end_date", star: false }),
    ...controls.magicDate({ tab: "account_documents", name: "doc_end_date", dateType: "ontype", minDate: '1 months from now' }),
    ...controls.displayText({ tab: "account_documents", label: "" }),
    ...controls.displayText({ tab: "account_documents", label: "Document", star: false }),
    ...controls.FileUpload({ tab: "account_documents", width: "col-sm-4", name: "document_uri", options: { max: 120000, type: "image" } }),

    ...controls.displayText({ tab: "account_documents", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "account_documents", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "account_documents",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "account_documents",
        requiredField: ["document_type_code", "document_type_display", "document_type_uid", "document_purpose_code", "document_purpose_display", "document_purpose_uid", "document_ref", "doc_start_date", "doc_end_date", "document_uri",],
        required: [],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "account_documents",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "account_documents",
        requiredField: ["document_type_code", "document_type_display", "document_type_uid", "document_purpose_code", "document_purpose_display", "document_purpose_uid", "document_ref", "doc_start_date", "doc_end_date", "document_uri",]
      }, width: "col-sm-2"
    }),
    {
      tab: "account_documents",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Document Type Code", field: "document_type_code" },
        { label: "Document Type ", field: "document_type_display" },
        { label: "Document Purpose Code", field: "document_purpose_code" },
        { label: "Document Purpose ", field: "document_purpose_display" },
        { label: "Doc No", field: "document_ref" },
        { label: "Doc Start Date", field: "doc_start_date", displaytype: "date" },
        { label: "Doc End Date", field: "doc_end_date", displaytype: "date" },
        { label: "Document", field: "document_uri", displaytype: "file" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "account_documents"
    },
    ...controls.displayText({ tab: "account_house_details", label: "House Type", star: false }),
    ...controls.oc({ tab: "account_house_details", c: "HouseType", placeHolder: "House Type Code", name: "house_type_code", fastpath: "house_types", hidden: false }),
    ...controls.showData({ tab: "account_house_details", displaytype: "capital", data: "house_type_display" }),
    ...controls.displayText({ tab: "account_house_details", label: "Vendor", star: false }),
    ...controls.oc({ tab: "account_house_details", c: "Vendor", placeHolder: "Vendor Code", name: "vendor_code", fastpath: "vendors", hidden: false }),
    ...controls.showData({ tab: "account_house_details", displaytype: "capital", data: "vendor_display" }),
    ...controls.displayText({ tab: "account_house_details", label: "Area Sqft" }),
    ...controls.floatOnly({ tab: "account_house_details", placeHolder: "", name: "area_sqft", maxlength: 10 }),
    ...controls.displayText({ tab: "account_house_details", label: "" }),
    ...controls.displayText({ tab: "account_house_details", label: "Ready Recknor Rate" }),
    ...controls.floatOnly({ tab: "account_house_details", placeHolder: "", name: "ready_recknor_rate", maxlength: 18 }),
    ...controls.displayText({ tab: "account_house_details", label: "" }),
    ...controls.displayText({ tab: "account_house_details", label: "Listed Price" }),
    ...controls.floatOnly({ tab: "account_house_details", placeHolder: "", name: "listed_price", maxlength: 10 }),
    ...controls.displayText({ tab: "account_house_details", label: "" }),
    ...controls.displayText({ tab: "account_house_details", label: "Sale Price" }),
    ...controls.floatOnly({ tab: "account_house_details", placeHolder: "", name: "sale_price", maxlength: 10 }),
    ...controls.displayText({ tab: "account_house_details", label: "" }),
    ...controls.displayText({ tab: "account_house_details", label: "Invoice Number", star: false }),
    ...controls.text({ tab: "account_house_details", placeHolder: "", name: "invoice_number", maxlength: 20 }),
    ...controls.displayText({ tab: "account_house_details", label: "" }),
    ...controls.displayText({ tab: "account_house_details", label: "Valuator", star: false }),
    ...controls.oc({ tab: "account_house_details", c: "Valuator", placeHolder: "Valuator Code", name: "valuator_code", fastpath: "valuators", hidden: false }),
    ...controls.showData({ tab: "account_house_details", displaytype: "capital", data: "valuator_display" }),
    {
      widths: "col-sm-12",
      tab: "account_house_details",
      title: "Address",
      subComponents: [
        ...controls.displayText({ tab: "account_house_details", label: "Line 1", star: false }),
        ...controls.text({ tab: "account_house_details", placeHolder: "", name: "address.line_1", width: "col-sm-4", maxlength: 100 }),
        ...controls.displayText({ tab: "account_house_details", label: "Line 2", star: false }),
        ...controls.text({ tab: "account_house_details", placeHolder: "", name: "address.line_2", width: "col-sm-4", maxlength: 100 }),
        ...controls.displayText({ tab: "account_house_details", label: "Line 3", star: false }),
        ...controls.text({ tab: "account_house_details", placeHolder: "", name: "address.line_3", width: "col-sm-4", maxlength: 100 }),
        ...controls.displayText({ tab: "account_house_details", label: "Village", star: true }),
        ...controls.oc({ tab: "account_house_details", c: "Village", placeHolder: "Village Code", name: "address.village_code", isRequired: true, fastpath: "villages", hidden: false }),
        ...controls.showData({ tab: "account_house_details", displaytype: "capital", data: "address.village_display" }),
        ...controls.displayText({ tab: "account_house_details", label: "Taluka", star: true }),
        ...controls.oc({ tab: "account_house_details", c: "Taluka", placeHolder: "Taluka Code", name: "address.taluka_code", isRequired: true, fastpath: "talukas", hidden: false }),
        ...controls.showData({ tab: "account_house_details", displaytype: "capital", data: "address.taluka_display" }),
        ...controls.displayText({ tab: "account_house_details", label: "District", star: true }),
        ...controls.oc({ tab: "account_house_details", c: "District", placeHolder: "District Code", name: "address.district_code", isRequired: true, fastpath: "districts", hidden: false }),
        ...controls.showData({ tab: "account_house_details", displaytype: "capital", data: "address.district_display" }),
        ...controls.displayText({ tab: "account_house_details", label: "State", star: true }),
        ...controls.oc({ tab: "account_house_details", c: "State", placeHolder: "State Code", name: "address.state_code", isRequired: true, fastpath: "states", hidden: false }),
        ...controls.showData({ tab: "account_house_details", displaytype: "capital", data: "address.state_display" }),
        ...controls.displayText({ tab: "account_house_details", label: "Country", star: true }),
        ...controls.oc({ tab: "account_house_details", c: "Country", placeHolder: "Country Code", name: "address.country_code", isRequired: true, fastpath: "countries", hidden: false }),
        ...controls.showData({ tab: "account_house_details", displaytype: "capital", data: "address.country_display" }),
        ...controls.displayText({ tab: "account_house_details", label: "Pincode", star: false }),
        ...controls.text({ tab: "account_house_details", placeHolder: "", name: "address.pincode", maxlength: 6 }),
        ...controls.displayText({ tab: "account_house_details", label: "" }),
        ...controls.displayText({ tab: "account_house_details", label: "Latitude" }),
        ...controls.floatOnly({ tab: "account_house_details", placeHolder: "", name: "address.latitude", maxlength: 10 }),
        ...controls.displayText({ tab: "account_house_details", label: "" }),
        ...controls.displayText({ tab: "account_house_details", label: "Longitude" }),
        ...controls.floatOnly({ tab: "account_house_details", placeHolder: "", name: "address.longitude", maxlength: 10 }),
        ...controls.displayText({ tab: "account_house_details", label: "" }),
        ...controls.displayText({ tab: "account_house_details", label: "Short Name", star: false }),
        ...controls.text({ tab: "account_house_details", placeHolder: "", name: "address.short_name", maxlength: 50 }),
        ...controls.displayText({ tab: "account_house_details", label: "" }),
      ]
    },

    ...controls.displayText({ tab: "account_house_details", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "account_house_details", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "account_house_details",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "account_house_details",
        requiredField: ["house_type_code", "house_type_display", "house_type_uid", "vendor_code", "vendor_display", "vendor_uid", "area_sqft", "ready_recknor_rate", "listed_price", "sale_price", "invoice_number", "valuator_code", "valuator_display", "valuator_uid",],
        required: ["area_sqft", "ready_recknor_rate",],
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "account_house_details",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "account_house_details",
        requiredField: ["house_type_code", "house_type_display", "house_type_uid", "vendor_code", "vendor_display", "vendor_uid", "area_sqft", "ready_recknor_rate", "listed_price", "sale_price", "invoice_number", "valuator_code", "valuator_display", "valuator_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "account_house_details",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "House Type Code", field: "house_type_code" },
        { label: "House Type ", field: "house_type_display" },
        { label: "Vendor Code", field: "vendor_code" },
        { label: "Builder ", field: "vendor_display" },
        { label: "Area Sqft", field: "area_sqft" },
        { label: "Ready Recknor Rate", field: "ready_recknor_rate" },
        { label: "Listed Price", field: "listed_price" },
        { label: "Sale Price", field: "sale_price" },
        { label: "Invoice Number", field: "invoice_number" },
        { label: "Valuator Code", field: "valuator_code" },
        { label: "Valuator ", field: "valuator_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "account_house_details"
    },
  ]
  , history: {
    perPage: 10,
    reportHeader: "Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Account Code", accessor: "account_code", },
      { Header: "Account Type", accessor: "Account-account_type-account_type_display", },
      { Header: "Customer Type", accessor: "Account-customer-customer_type-customer_type_display", },
      { Header: "First Name", accessor: "Account-customer-individual_details-first_name", },
      { Header: "Last Name", accessor: "Account-customer-individual_details-last_name", },
      { Header: "Full Name", accessor: "Account-customer-institutional_details-full_name", },
      { Header: "Branch Code", accessor: "Account-branch-branch_code", },
      { Header: "Account Active", accessor: "account_active", type: 'tick' },
    ]
  }
};
export default accounts;